export const lazyComponents: Record<string, () => Promise<any>> = {
  suivi:      () => import('@pages/suivi.component').then(m => m.SuiviComponent),
  documents:  () => import('@pages/documents.component').then(m => m.DocumentComponent),
  messages:   () => import('@pages/messages.component').then(m => m.MessageComponent),
  transmettre: () => import('@pages/transmettre.component').then(m => m.TransmettreComponent),
}